// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsFilledSvg from "@fishx/icons-svg/es/asn/SnippetsFilled";
import FishxIcon from '../components/FishxIcon';

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsFilledSvg
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
export default React.forwardRef(SnippetsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SnippetsFilled.js
// module id = 4157
// module chunks = 0